import React, { useState, Fragment } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import styled from "styled-components";

const HeroDiv = styled.div`

.herocard-container {
display: block;
padding: 2px;
}
.herocard-image {
    width: calc(100% + 3px);
margin-left: -2px;
box-shadow: 0 0 4px rgba(0,0,0,0.2);
object-fit: cover;
height: 132px;
padding-left: 2px;
padding-right: 2px;
}
.herocard-text-area {
    padding: 10px;
}

.herocard-title-text {
    color: #444444;
    font-weight: bold;
    font-size: 17px;
    padding-bottom: 2px;
    width:  calc(100% + 4px);
}

.herocard-button-col-container {
    width:  calc(100% + 0px);
}

.herocard-button-row-container {
    display: flex;
    width:  calc(100% + 4px);
    flex-direction: row;
}

.herocard-button-row {
    flex: 1;
}

.herocard-button-row:not(:first-child) {
    border-left: 2px solid #e9eef4;
}

.herocard-button-row:not(:first-child):hover {
    border-left: 2px solid rgba(45,58,58,0);
}

.herocard-button-col {
    width: 100%;
}

.herocard-button {
    font-size: 15px;
border-top: 2px solid white;
text-align: center;
padding: 5px;
cursor: pointer;
}

.herocard-button:hover {
}
.below{
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 20px;
}
`;
const HeroCard = ({ item, sender, color }) => {
    const cardData = JSON.parse(item);
    function handleClick(path, type) {
        if (type === "openUrl" && path.includes(":Webview")) {
            var IndexWebview = path.split(":Webview");
            var Jsondata = JSON.parse(IndexWebview[1]);
            window.open(IndexWebview[0]);
        }
        else if (type === "openUrl" && !path.includes(":Webview")) {
            window.open(path);
        }
        else if (type === "messageBack") {
            var Jsondata = JSON.parse(path);
            window.open(Jsondata.url);
        }
    }
    return (
        <HeroDiv>
            <div className="herocard-container">
                {cardData.content.images !== undefined && cardData.content.images.length > 0 ?
                    cardData.content.images.map((img) =>
                        (<img className="herocard-image" src={img.url} alt=""></img>)
                    )
                    : ""
                }
                <div className="herocard-text-area">
                    <div className="ac-textBlock herocard-title-text">{cardData.content.title}</div>
                    <div className="ac-textBlock">
                        <span>{cardData.content.text}</span>
                    </div>
                </div>
                <div className="herocard-button-col-container">
                    {cardData.content.buttons.map((e) =>
                        (() => {
                            switch (e.type) {
                                case "imBack":
                                    return (
                                        <div className="herocard-button herocard-button-col below"
                                            style={{
                                                backgroundColor: color.heroButtonBackground,
                                                color: color.heroButtonText,
                                                cursor: "pointer"
                                            }}>{e.value}</div>
                                    );
                                case "openUrl":
                                    return (
                                        <div className="herocard-button herocard-button-col below"
                                            onClick={() => handleClick(e.value, e.type)}
                                            style={{
                                                backgroundColor: color.heroButtonBackground,
                                                color: color.heroButtonText,
                                                cursor: "pointer"
                                            }}>{e.title}</div>
                                    );
                                case "messageBack":
                                    return (
                                        <div className="herocard-button herocard-button-col below"
                                            onClick={() => handleClick(e.value, e.type)}
                                            style={{
                                                backgroundColor: color.heroButtonBackground,
                                                color: color.heroButtonText,
                                                cursor: "pointer"
                                            }}>{e.title}</div>
                                    );
                                default:
                                    break;
                            }
                        }
                        )()
                    )}
                </div>
            </div>
        </HeroDiv>
    );
};

export default HeroCard;
